import { render } from "./representante-fatca.vue?vue&type=template&id=0699328e&scoped=true"
import script from "./representante-fatca.vue?vue&type=script&lang=js"
export * from "./representante-fatca.vue?vue&type=script&lang=js"

import "./representante-fatca.vue?vue&type=style&index=0&id=0699328e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0699328e"]])

export default __exports__